import { useEffect, useState } from 'react';
import useMapInstance from './useMapInstance';
export default (instance, setInstance, customAdd) => {
    const mapInstance = useMapInstance();
    const [componentInstance, setComponentInstance] = useState();
    // Cleanup
    useEffect(() => () => {
        if (componentInstance && mapInstance.hasLayer(componentInstance)) {
            componentInstance.removeFrom(mapInstance);
        }
    }, [componentInstance, mapInstance]);
    // Add to map instance
    useEffect(() => {
        if (!componentInstance) {
            setComponentInstance(customAdd
                ? customAdd(instance, mapInstance)
                : instance.addTo(mapInstance));
        }
    }, [instance, mapInstance, setInstance]);
    // Call setInstance when componentInstance is set
    useEffect(() => {
        if (setInstance && componentInstance) {
            setInstance(componentInstance);
        }
    }, [componentInstance, setInstance]);
};
//# sourceMappingURL=useAddToMapInstance.js.map